
import { BlogModel } from 'tradingmate-modules/src/models/api/blogs'
import { Services } from 'tradingmate-modules/src/services'
import { Vue, Component, Watch } from 'vue-property-decorator'
import PostNav from '@/components/layout/PostNav.vue'
import FacebookShare from '@/components/actions/FacebookShare.vue'
import Utils from 'tradingmate-modules/src/Utils'
import FormattedText from '@/components/typography/FormattedText.vue'
import Gallery from '@/components/layout/Gallery.vue'
import BlogAnalyticEventCreateDto from 'tradingmate-modules/src/models/api/analytic-event/BlogAnalyticalEventCreateDto'
import BlogAnalyticEventType from 'tradingmate-modules/src/models/api/analytic-event/BlogAnalyticEventType'
import { BusinessBranchModel, SocialLinkType } from 'tradingmate-modules/src/models/api/businesses'
import ContactMethodType from 'tradingmate-modules/src/models/api/ContactMethodType'
import { UserModel } from 'tradingmate-modules/src/models/api/users'

@Component({
  components: {
    FormattedText,
    PostNav,
    FacebookShare,
    Gallery
  }
})
export default class ToolboxTalkDetails extends Vue {
  private blog: BlogModel | null = null
  private member: BusinessBranchModel | null = null
  private user: UserModel | null = null
  private loading = false
  private isoToDisplayDate = Utils.isoToDisplayDate

  get galleryImages (): string[] | null {
    var images = this.blog?.Images?.map((img) => { return img.Normal }) ?? null
    return images
  }

  async mounted (): Promise<void> {
    await this.getToolboxTalkPost()
    this.GetBranch()
    this.pagedViewed()
  }

  @Watch('$route')
  async getToolboxTalkPost (): Promise<void> {
    var slug = this.$route.params.slug
    await Services.API.Blogs.GetBlogBySlug(slug)
      .then(returnBlog => { this.blog = returnBlog })
  }

  async GetBranch (): Promise<void> {
    if (this.blog?.BusinessBranchSlug == null) return
    this.loading = true

    await Services.API.Businesses.GetBranchBySlug(this.blog.BusinessBranchSlug)
      .then(responseData => {
        this.member = responseData
      }).catch((errors) => {
        console.log(errors)
      }).finally(() => {
        this.loading = false
      })

    // Get Admin User
    if (this.member == null) return

    await Services.API.Businesses.GetUserForBusinessBranch(this.member.BusinessBranchId)
      .then(responseData => {
        this.user = responseData
      }).catch((errors) => {
        console.log(errors)
      }).finally(() => {
        this.loading = false
      })

    console.log(this.member)
    console.log(this.user)
  }

  handlePrevPost (): void {
    var slug = this.$route.params.slug
    Services.API.Blogs.PreviousBlog(slug).then(returnBlog => {
      this.$router.push({
        name: 'Toolbox Talk Details',
        params: {
          slug: returnBlog.Slug
        }
      })
    })
  }

  handleNextPost (): void {
    var slug = this.$route.params.slug
    Services.API.Blogs.NextBlog(slug).then(returnBlog => {
      this.blog = returnBlog
      this.$router.push({
        name: 'Toolbox Talk Details',
        params: {
          slug: returnBlog.Slug
        }
      })
    })
  }

  private viewedDto: BlogAnalyticEventCreateDto = { Type: BlogAnalyticEventType.BlogView }
  pagedViewed (): void {
    if (this.blog === null) return
    Services.API.AnalyticEvent.CreateBlogAnalyticEvent(this.blog.BlogId, this.viewedDto)
  }

  get mobileContact (): string | undefined {
    return this.member?.ContactMethods.find(
      contact => contact.ContactMethodType === ContactMethodType.MobilePhone
    )?.Value
  }

  get landlineContact (): string | undefined {
    return this.member?.ContactMethods.find(
      contact => contact.ContactMethodType === ContactMethodType.Landline
    )?.Value
  }

  get emailContact (): string | undefined {
    return this.member?.ContactMethods.find(
      contact => contact.ContactMethodType === ContactMethodType.Email
    )?.Value
  }

  getLinkIcon (socialLinkType: SocialLinkType): string {
    switch (socialLinkType) {
      case SocialLinkType.Facebook:
        return '/assets/icons/social/facebook.svg'
      case SocialLinkType.Website:
        return '/assets/icons/social/website.svg'
      case SocialLinkType.Instagram:
        return '/assets/icons/social/instagram.svg'
      case SocialLinkType.Linkedin:
        return '/assets/icons/social/linkedin.png'
      case SocialLinkType.GoogleMyBusiness:
        return '/assets/icons/social/google-my-business.svg'
      case SocialLinkType.Video:
        return '/assets/icons/social/video.svg'
      case SocialLinkType.Twitter:
        return '/assets/icons/social/twitter.svg'
      case SocialLinkType.TripAdvisor:
        return '/assets/icons/social/tripadvisor.svg'
      case SocialLinkType.Pinterest:
        return '/assets/icons/social/pinterest.svg'
      case SocialLinkType.Etsy:
        return '/assets/icons/social/etsy.svg'
      default:
        return ''
    }
  }

  getLinkName (socialLinkType: SocialLinkType): string {
    switch (socialLinkType) {
      case SocialLinkType.Facebook:
        return 'Facebook'
      case SocialLinkType.Website:
        return 'Website'
      case SocialLinkType.Instagram:
        return 'Instagram'
      case SocialLinkType.Linkedin:
        return 'Linkedin'
      case SocialLinkType.GoogleMyBusiness:
        return 'Google My Business'
      case SocialLinkType.Video:
        return 'Video'
      case SocialLinkType.Twitter:
        return 'Twitter'
      case SocialLinkType.TripAdvisor:
        return 'TripAdvisor'
      case SocialLinkType.Pinterest:
        return 'Pinterest'
      case SocialLinkType.Etsy:
        return 'Etsy'
      default:
        return ''
    }
  }

  get logo (): string | null {
    const logo = this.member?.Logo?.Normal ?? null
    return logo
  }
}
